import { atom } from "recoil";

import { IClienteInfo } from "../interfaces/IClienteInfo";

export const clientInfoState = atom<IClienteInfo>({
    key: "clientInfoState",
    default: undefined,
});
